export const checkAuth = () => ({ type: 'CHECK_AUTH' });
export const userHandlerAuth = (data) => ({ type: 'USER_HANDLER_AUTH', data });
export const setDataProfile = (data) => ({ type: 'SET_DATA_PROFILE', data });
export const setCurrentCertificateData = (data) => ({
  type: 'SET_CURRENT_CERTIFICATE',
  data,
});
